import { Button, Box, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import styles from "./RecordNavbar.module.scss";
import { RecordNavbarProps } from "../../interface";

/**
 * RecordNavbar component renders a search bar and sample generation action.
 *
 * @component
 * @param {Object} props
 * @param {string} props.searchData - Current value of the search input.
 * @param {boolean} props.disabled - Whether sample generation is disabled.
 * @param {Function} props.handleGenerateSummary - Callback to trigger sample generation.
 * @param {Function} props.onSearchChange - Callback when the search input changes.
 */
const RecordNavbar = ({
  searchData,
  disabled,
  handleGenerateSummary,
  onSearchChange,
  onSearchSubmit,
}: RecordNavbarProps) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      onSearchSubmit();
    }
  };

  return (
    <Box className={styles.container}>
      <TextField
        placeholder="Search..."
        variant="outlined"
        size="small"
        className={styles.searchBar}
        InputProps={{
          startAdornment: <SearchIcon className="search-icon" />,
        }}
        data-testid="search-bar"
        value={searchData}
        onChange={(e) => onSearchChange(e.target.value)}
        onKeyDown={handleKeyDown}
        autoComplete="off"
      />
      <Button
        variant="contained"
        className={styles.actionBtn}
        onClick={onSearchSubmit}
        data-testid="search-button"
      >
        Search
      </Button>
      <Box className={styles.actions}>
        <Button
          variant="contained"
          className={styles.actionBtn}
          disabled={disabled}
          data-testid="generate-button"
          onClick={handleGenerateSummary}
        >
          Generate sample
        </Button>
      </Box>
    </Box>
  );
};

export default RecordNavbar;
